import { render } from "./W3Sidebar.vue?vue&type=template&id=932dd954&scoped=true&ts=true"
import script from "./W3Sidebar.ts?vue&type=script&lang=ts"
export * from "./W3Sidebar.ts?vue&type=script&lang=ts"

import "./W3Sidebar.vue?vue&type=style&index=0&id=932dd954&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932dd954"]])

export default __exports__